import request from 'utils/http.js'

/** 添加事件（代码埋点方式） */
export function totalApi(id, name) {
	let query = {
		"maskId": "3MEUOiKrtxIh9V4D",
		"track": id,// 事件标识
		"name": name,// 事件名称
		"accessKey": "1FeGR4DuBMwGDpZ5H6NgrNoPpBfjcH3k",
		"nonce": "1234",
		"timestamp": new Date().getTime(),
		"sign": "1FeGR4DuBMwGDpZ5H6NgrNoPpBfjcH3k"// 低安全验证
	}
	return request({
		url: 'https://v6-open.51.la/open/event/add',
		method: 'post',
		data: query
	})
}
async function getDataFn(id, name) {
	try{
		let query = {
			"maskId": "", // 我的应用统计maskId，掩码ID
			"track": id,// 事件标识
			"name": name,// 事件名称
			"accessKey": "", // 请修改为您的 accessKey，用户标识码/公共校验参数
			"nonce": "", // 4位随机字符串/公共校验参数
			"timestamp": new Date().getTime(), // 13位时间戳(毫秒级)/公共校验参数
			"sign": "" // 请修改为您的加密 sign，低安全验证情况下，为accessKey
		}
		let res = await totalApi(query)
		console.log('事件统计回调', res)
		if(res.code == 200){}
	}catch(err){
		console.log('事件统计出错', err)
	}
}